class FetchAccountWorkflows {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAccountWorkflows;
